import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConfirmComponent, ImageCropperComponent } from '@core/components';
import { ProfileService } from '@app/profile/services/profile.service';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { BlobToFile, DataURIToBlob } from '@app/utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-avatar-photo',
  templateUrl: './avatar-photo.component.html',
  styleUrls: ['./avatar-photo.component.css']
})
export class AvatarPhotoComponent implements OnChanges, OnDestroy {

  @Input() photo: string;
  @Input() firstname: string;
  @Input() editable: boolean = false;

  @Output() photoChange: EventEmitter<any> = new EventEmitter<any>();

  public environment = environment;
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private modalService: NgbModal,
    private profileService: ProfileService,
    private toastService: ToastrService,
    private translate: TranslateService,
  ) { }

  ngOnChanges(changes: SimpleChanges) { }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  fileChangeEvent(event): void {
    if (event.target.files.length) {
      const modalRef = this.modalService.open(ImageCropperComponent, { centered: true });
      modalRef.componentInstance.aspectRatio = 1;
      modalRef.componentInstance.file = event.target.files[0];
      modalRef.componentInstance.roundCropper = true;
      modalRef.closed.subscribe(res => {
        const file = DataURIToBlob(res);
        const fileName = event.target.files[0].name.split('.')[0] + '.' + file.type.split('/')[1];
        const imageFile = BlobToFile(file, fileName);
        const formData = new FormData();
        formData.append('image', imageFile)
        this.profileService.updateAvatar(formData)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: res => {
              this.photoChange.emit(res);
              event.target.value = null;
            },
            error: err => {
              this.toastService.error(err)
            }
          })
      });
    }
  }

  deleteAvatar(): void {
    const modalRef = this.modalService.open(ConfirmComponent, { centered: true });
    modalRef.componentInstance.title = this.translate.instant('general.delete_avatar_title');
    modalRef.componentInstance.text = this.translate.instant('general.delete_avatar_text');
    modalRef.closed.subscribe(res => {
      this.profileService.removeAvatar()
        .pipe()
        .subscribe({
          next: () => {
            this.photoChange.emit({ avatarPath: null });
          },
          error: err => {
            this.toastService.error(err, this.translate.instant('general.error_message'));
          }
        })
    });
  }

}
